export default {
  // Inventory
  "inventory": "Inventaire",
  "film_inventory": "Inventaire de films",
  "camera_inventory": "Inventaire d'appareils photo",
  "lens_inventory": "Inventaire d'objectifs",
  "add_film": "Ajouter un film",
  "add_camera": "Ajouter un appareil photo",
  "add_lens": "Ajouter un objectif",
  "brand": "Marque",
  "film_name": "Nom du film",
  "film_type": "Type de film",
  "iso": "ISO",
  "format": "Format",
  "quantity": "Quantité",
  "expiration_date": "Date d'expiration",
  "notes": "Notes",
  "status": "Statut",
  "new": "Neuf",
  "opened": "Ouvert",
  "exposed": "Exposé",
  "developed": "Développé",
  "archived": "Archivé",
  "film_details": "Détails du film",
  "expiration": "Expiration",
  "last_updated": "Dernière mise à jour",
  "edit_film": "Modifier le film",
  "delete_film": "Supprimer le film",
  "transfer_film": "Transférer le film",
  "transfer_to_camera": "Transférer vers l'appareil photo",
  "select_camera": "Sélectionner un appareil photo",
  "no_cameras": "Pas d'appareils photo",
  "add_a_camera": "Ajouter un appareil photo",
  "type": "Type",
  "mount": "Monture",
  "failed_load_film_details": "Échec du chargement des détails du film",
  "camera_details": "Détails de l'appareil photo",
  "lens_details": "Détails de l'objectif",
  "compatible_with": "Compatible avec",
  "no_films_found": "Aucun film trouvé",
  "add_your_first_film": "Ajoutez votre premier film",
  "track_your_collection": "Suivez votre collection de films argentiques",
  "no_cameras_found": "Aucun appareil photo trouvé",
  "add_your_first_camera": "Ajoutez votre premier appareil photo",
  "no_lenses_found": "Aucun objectif trouvé",
  "add_your_first_lens": "Ajoutez votre premier objectif",
  "sort": "Trier",
  "make": "Fabricant",
  "model": "Modèle",
  "focal_length": "Longueur focale",
  "aperture": "Ouverture",
  "min_aperture": "Ouverture min",
  "max_aperture": "Ouverture max",
  "filter_size": "Taille du filtre",
  "year": "Année",
  "serial": "Numéro de série",
  "large_format": "Grand Format",
  "medium_format": "Format Moyen",
  "cameras": "Appareils Photo",
  "lenses": "Objectifs",
  "film": "Film",
  "camera_type": "Type d'Appareil Photo",
  "no_films_yet": "Vous n'avez pas encore de pellicules",
};
